<template>
  <!-- 分页 -->
  <div class="bottomTool">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="customPagination.currentPage"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="customPagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="customPagination.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs, watch, toRaw } from "vue";
export default {
  name: "PaginationTool",
  props: {
    pagination: {
      type: Object,
      default: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    },
    isLoading: Boolean,
  },
  emits: {
    "change-pagination": null,
  },
  setup(props, { emit }) {
    const data = reactive({
      customPagination: {},
    });
    // 获取父组件props
    const propsData = JSON.parse(JSON.stringify(props));
    if (propsData) {
      data.customPagination = propsData.pagination;
    }
    // 监听分页
    watch(props.pagination, (newProps) => {
      // console.log(newProps, "currentBcurrentB");
      data.customPagination = JSON.parse(JSON.stringify(newProps));
    });

    // 每页数量
    const handleSizeChange = (val) => {
      data.customPagination.pageSize = val;
      eventTrigger();
    };
    // 前往x页
    const handleCurrentChange = (val) => {
      data.customPagination.currentPage = val;
      eventTrigger();
    };
    // 向父组件发送事件
    function eventTrigger() {
      emit("change-pagination", data.customPagination);
    }

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      handleSizeChange,
      handleCurrentChange,
    };
  },
};
</script>

<style scoped>
.bottomTool {
  width: 100%;
  width: 100%;
  margin-top: 10px;
  justify-content: flex-end;
}
::v-deep .el-pager li {
  outline: none;
}

::v-deep .el-pagination__total {
  margin-right: auto !important;
  margin-left: 5px !important;
}
</style>

